import React, { useMemo, useState } from 'react';
import { Box, Tab, Typography } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useParams } from 'react-router-dom';
//
import General from './tabs/General';
import Subscription from './tabs/Subscription';
import Settings from './tabs/Settings';
import Gateway from './tabs/Gateway';
import ConfirmationDialog from 'components/common/ConfirmationDialog';
import { useBoolFlag } from 'hooks/index';
import { EditFormContainer } from 'components/common/Containers';
import { useHasPermissions } from 'hooks/useHasPermissions';
import { PERMISSIONS } from '../../../constants';
import { ConfirmNavigation } from 'components/common/ConfirmNavigation';

export default function EditPage() {
  const { id } = useParams();
  const canEditClient = useHasPermissions(PERMISSIONS.CLIENTS_MANAGEMENT);
  const isUpdate = useMemo(() => !!id, [id]);
  const [activeTab, setActiveTab] = useState('1');
  const { isOn, setOn, setOff } = useBoolFlag();
  const [targetTab, setTargetTab] = useState('1');
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const checkAndNavigate = (e, newValue) => {
    if (newValue === activeTab) {
      return;
    }
    if (hasUnsavedChanges) {
      setTargetTab(newValue);
      setOn();
      return;
    }
    setActiveTab(newValue);
  };

  const handleChange = () => {
    setOff();
    setActiveTab(targetTab);
    setHasUnsavedChanges(false);
  };

  return (
    <EditFormContainer>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={activeTab}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={checkAndNavigate} aria-label='tabs'>
              <Tab label='General' value='1' />
              <Tab label='Subscription' value='2' disabled={!isUpdate} />
              <Tab label='Gateway' value='3' disabled={!isUpdate} />
              <Tab label='Settings' value='4' disabled={!isUpdate} />
            </TabList>
          </Box>
          <TabPanel value='1'>
            <General
              id={id}
              editable={canEditClient}
              onFormStateChanged={setHasUnsavedChanges}
            />
          </TabPanel>
          <TabPanel value='2'>
            <Subscription
              id={id}
              editable={canEditClient}
              onFormStateChanged={setHasUnsavedChanges}
            />
          </TabPanel>
          <TabPanel value='3'>
            <Gateway
              id={id}
              editable={canEditClient}
              onFormStateChanged={setHasUnsavedChanges}
            />
          </TabPanel>
          <TabPanel value='4'>
            <Settings
              id={id}
              editable={canEditClient}
              onFormStateChanged={setHasUnsavedChanges}
            />
          </TabPanel>
        </TabContext>
      </Box>
      <ConfirmNavigation
        isBlocked={hasUnsavedChanges}
        forceOpen={isOn}
        onSubmit={handleChange}
        onCancel={setOff}
      >
        {({ isOpen, handleCancel, handleSubmit }) => (
          <ConfirmationDialog
            isOpen={isOpen}
            title={
              <Typography variant='h5' component='p'>
                Unsaved changes detected
              </Typography>
            }
            contentText={
              <span>
                <Typography component='span' display='block'>
                  Leaving tab will discard your input.
                </Typography>
                <Typography component='span' display='block'>
                  Are you sure?
                </Typography>
              </span>
            }
            approveLabel='Proceed'
            handleClose={handleCancel}
            handleConfirm={handleSubmit}
          />
        )}
      </ConfirmNavigation>
    </EditFormContainer>
  );
}
